import { render, staticRenderFns } from "./CustomizeProduct.vue?vue&type=template&id=67582c98&scoped=true&"
import script from "./CustomizeProduct.vue?vue&type=script&lang=js&"
export * from "./CustomizeProduct.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeProduct.vue?vue&type=style&index=0&id=67582c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67582c98",
  null
  
)

/* custom blocks */
import block0 from "./CustomizeProduct.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports